import { render } from "./Tarefas.vue?vue&type=template&id=0a7ea570&ts=true"
import script from "./Tarefas.vue?vue&type=script&lang=ts"
export * from "./Tarefas.vue?vue&type=script&lang=ts"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__